export class ResponsePregunta {
    descripcioPregunta: string;
    descripcioResposta: string;
    id: number;
    idResposta: number = 0;
    idsRespostes: Array<number> = [];
    tipusPregunta: number;
}